export default __webpack_public_path__ + "static/media/border-3.1136da3e.webp";